module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.$route.path.indexOf('_editor') === -1) ? _c('div', [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "md": 4,
      "lg": 8
    }
  }, [_c('el-button', {
    attrs: {
      "size": "mini",
      "type": "primary",
      "icon": "plus"
    },
    on: {
      "click": _vm.addGive
    }
  }, [_vm._v("添加充值赠送")])], 1)], 1), _vm._v(" "), _c('el-tabs', {
    attrs: {
      "type": "border-card"
    },
    model: {
      value: (_vm.activeName),
      callback: function($$v) {
        _vm.activeName = $$v
      },
      expression: "activeName"
    }
  }, [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.list,
      "element-loading-text": "数据加载中"
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "id",
      "width": "60",
      "label": "编号"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "line_name",
      "label": "活动名称"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "line_many",
      "label": "赠送金额"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "items",
      "label": "关联商品"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.handleDialogGoods(scope.row, scope.row.id)
            }
          }
        }, [_vm._v("查看商品")])]
      }
    }], null, false, 2937765547)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "是否开启",
      "width": "120",
      "show-overflow-tooltip": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-switch', {
          attrs: {
            "active-value": 1,
            "inactive-value": 0,
            "active-color": "#13ce66",
            "inactive-color": "#ff4949"
          },
          on: {
            "change": function($event) {
              return _vm.switchRecord(scope.$index, scope.row)
            }
          },
          model: {
            value: (scope.row.status),
            callback: function($$v) {
              _vm.$set(scope.row, "status", $$v)
            },
            expression: "scope.row.status"
          }
        })]
      }
    }], null, false, 57671176)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "开始时间",
      "width": "200"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(_vm._f("datetime")(scope.row.start_time, 'yyyy-MM-dd hh:mm:ss')))])]
      }
    }], null, false, 1408255640)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "结束时间",
      "width": "200"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(_vm._f("datetime")(scope.row.end_time, 'yyyy-MM-dd hh:mm:ss')))])]
      }
    }], null, false, 1851373527)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "width": "150"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          staticClass: "operating-icons"
        }, [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.updateGive(scope.row)
            }
          }
        }, [_vm._v("编辑\n                            ")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.deleteGive(scope.row.id)
            }
          }
        }, [_vm._v("刪除\n                            ")])], 1)]
      }
    }], null, false, 2034596301)
  })], 1), _vm._v(" "), (_vm.total_count > _vm.params.pageSize) ? _c('div', {
    staticClass: "content-padded content-center"
  }, [_c('el-pagination', {
    attrs: {
      "layout": "prev, pager, next",
      "current-page": _vm.params.page,
      "total": _vm.total_count,
      "page-size": _vm.params.pageSize
    },
    on: {
      "current-change": _vm.handleCurrentChange,
      "update:currentPage": function($event) {
        return _vm.$set(_vm.params, "page", $event)
      },
      "update:current-page": function($event) {
        return _vm.$set(_vm.params, "page", $event)
      }
    }
  })], 1) : _vm._e()], 1)], 1) : _vm._e(), _vm._v(" "), _c('router-view'), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.goodsDialog.goodsTitle,
      "visible": _vm.goodsDialog.goodsVisible,
      "before-close": _vm.handleGoodsDialogCancel
    },
    on: {
      "update:visible": function($event) {
        return _vm.$set(_vm.goodsDialog, "goodsVisible", $event)
      }
    }
  }, [_c('el-row', {
    attrs: {
      "title": "商品列表",
      "type": "info",
      "description": "",
      "show-icon": ""
    }
  }), _vm._v(" "), _c('el-row', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.goodsDialog.dialogLoading),
      expression: "goodsDialog.dialogLoading"
    }],
    attrs: {
      "gutter": 10
    }
  }, [_c('el-col', {
    attrs: {
      "md": 23
    }
  }, [_c('el-table', {
    ref: "multipleTable",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.goodsList,
      "tooltip-effect": "dark"
    }
  }, [(false) ? _c('el-table-column', {
    attrs: {
      "prop": "item_id",
      "label": "商品id"
    }
  }) : _vm._e(), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "item_name",
      "label": "商品名称",
      "width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('router-link', {
          staticClass: "btn-gap",
          attrs: {
            "to": {
              path: _vm.matchInternalRoute('goodsphysical_editor') + '/' + scope.row.item_id
            }
          }
        }, [_vm._v(_vm._s(scope.row.item_name))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "item_bn",
      "label": "商品编号"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (false),
            expression: "false"
          }]
        }, [_vm._v("商品id:" + _vm._s(scope.row.item_id))]), _vm._v(_vm._s(scope.row.item_bn))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "item_bn",
      "label": "商品来源"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.item_from == 'store') ? _c('el-tag', {
          attrs: {
            "size": "mini",
            "effect": "plain",
            "type": "success"
          }
        }, [_vm._v("店铺")]) : (scope.row.item_from == 'shop') ? _c('el-tag', {
          attrs: {
            "size": "mini",
            "effect": "plain",
            "type": "success"
          }
        }, [_vm._v("商城")]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "brief",
      "label": "商品简介",
      "show-overflow-tooltip": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "price",
      "label": "销售价格"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "market_price",
      "label": "市场价格"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "is_record",
      "label": "商品图片",
      "width": "90"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-popover', {
          attrs: {
            "placement": "right",
            "width": "240",
            "trigger": "hover"
          }
        }, [_c('div', {
          staticStyle: {
            "overflow-y": "scroll",
            "overflow-x": "hidden",
            "height": "240px",
            "text-align": "center"
          }
        }, _vm._l((scope.row.pics), function(v) {
          return _c('img', {
            staticClass: "goods-popover-img",
            staticStyle: {
              "width": "92%"
            },
            attrs: {
              "src": v
            }
          })
        }), 0), _vm._v(" "), _c('el-button', {
          attrs: {
            "slot": "reference",
            "type": "text"
          },
          slot: "reference"
        }, [_c('img', {
          attrs: {
            "src": "/static/img/icon_img.png"
          }
        })])], 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    staticClass: "content-center content-top-padded"
  }, [_c('el-pagination', {
    attrs: {
      "background": "",
      "layout": "total, sizes, prev, pager, next",
      "current-page": _vm.goodsDialog.goodsParams.page,
      "page-sizes": [100, 200, 300],
      "total": _vm.goodsList.total_count,
      "page-size": _vm.goodsDialog.goodsParams.pageSize
    },
    on: {
      "current-change": _vm.handleGoodsDialogCurrentChange,
      "size-change": _vm.handleGoodsDialogSizeChange,
      "update:currentPage": function($event) {
        return _vm.$set(_vm.goodsDialog.goodsParams, "page", $event)
      },
      "update:current-page": function($event) {
        return _vm.$set(_vm.goodsDialog.goodsParams, "page", $event)
      }
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer position-left",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.goodsDialog.goodsVisible = false
      }
    }
  }, [_vm._v("取 消")])], 1)], 1)], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-87b00796", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-87b00796"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/member/promotions/recharge_offline/list.vue
// module id = 2874
// module chunks = 0